module.exports = __webpack_public_path__ + "static/media/loader.4701c7a4.png";